/**
* @name: page-card-space
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-card-space
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('基础间距')}}</span>
    <div class="themeAttr-item-body w100b">
      <a-slider id="test" v-model:value="baseSpace" :max="36" :min="8" :marks="marks"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "page-card-space",
});
</script>

<script lang="ts" setup>
import {Slider as ASlider} from "ant-design-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useI18n} from "vue-i18n";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import {setCssVar} from "@/logics/theme/util";
import {BASE_SPACE} from "@/logics/initAppConfig";
const {t} = useI18n();
const { getBaseSpace } = useRootSetting();

const baseSpace=ref(unref(getBaseSpace));
const marks = ref<Record<number, any>>({
  8: '8px',
  12: '12px',
  18: '18px',
  24: '24px',
  30: '30px',
  36: '36px',
});

//设置卡片空间
watch(baseSpace,(newVal)=>{
  baseHandler(HandlerEnum.BASE_SPACE, unref(newVal));
  //基础间距
  setCssVar(BASE_SPACE, newVal+'px');
})

const {prefixCls} = useDesign('page-card-space');
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-card-space';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold,PingFang SC;
  .themeAttr-item-body{
    flex-wrap: wrap;
  }
  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }
  .itme-title-span{
    text-align: center;
    margin-top: 6px;
  }
  .item-type-sign {
    width: 56px;
    height: 56px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
</style>
